<template>
    <div class="discuss-container">
        <div class="discuss-content">
            <!-- <el-breadcrumb separator-class="el-icon-arrow-right" v-if="role === 3">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackTwo">班级管理</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">{{className}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>讨论列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">{{className}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>讨论列表</el-breadcrumb-item>
            </el-breadcrumb> -->
            <div style="color: #8F8F8F; margin-bottom: 24px;">
                当前位置：
                <span @click="goBackTwo" v-if="role === 3" style="cursor: pointer;">班级管理 > </span>
                <span @click="goBack" style="cursor: pointer;">{{ className }}</span>
                <span> > 讨论列表</span>
            </div>
            <div class="discuss-list">
                <div style="display: flex; justify-content: space-between;">
                    <div style="color: #000; font-size: 24px; display: flex; align-items: center;">
                        <div style="width: 6px; height: 32px; background: #006EFF; border-radius: 4px; margin-right: 10px;"></div>
                        讨论列表
                    </div>
                    <el-button  type="primary" @click="goBack">返 回</el-button>
                </div>
                <el-table :data="discussList" style="width: 100%; flex: 1; margin-top: 30px; border: 1px solid #EBEEF5; border-bottom: none; border-radius: 4px;" stripe :header-cell-style="headStyle" :cell-style="cellStyle">
                    <el-table-column prop="course_id" label="课程序号" width="150" ></el-table-column>
                    <el-table-column prop="course_name" label="课程名称"></el-table-column>
                    <el-table-column prop="discuss_num" label="讨论数" width="180" align="center"></el-table-column>
                    <el-table-column prop="teach_hours" label="授课时间" width="180" align="center"></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="clickViewDetail(scope.row)" :underline="false" style="color: #006EFF">查看详情</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                               class="pages-center" background
                               :current-page.sync="discussPages.currentPageNum"
                               :page-size="discussPages.eachPageNum"
                               :total="discussPages.total"
                               layout="prev, pager, next, jumper"
                               @current-change="discussCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "discussList",
        data() {
            return {
                //班级名称，课程id，上课记录id
                className: this.$route.query.className || '',
                classId: Number(this.$route.query.classId) || '',
                recordId: Number(this.$route.query.recordId) || '',
                //讨论列表数据
                discussList: [],
                //分页
                discussPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                role: Number(localStorage.getItem('role'))
            }
        },
        created() {
            this.getDiscussList();
        },
        methods: {
            headStyle() {
                return 'background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
            },
            cellStyle() {
                return 'padding-left: 24px; height: 60px; color: #333;'
            },
            //获取讨论列表
            getDiscussList() {
                let param = {
                    c_id: this.classId,
                    page: this.discussPages.currentPageNum,
                    limit: this.discussPages.eachPageNum,
                }
                this.$shttp.axiosGetBy(this.$api.showDiscussList, param, (res) => {
                    if (res.code === 200) {
                        this.discussList = res.data.data
                        this.discussPages.total = res.data.total
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            //分页
            discussCurrentChange(val) {
                this.discussPages.currentPageNum = val;
                this.getDiscussList();
            },
            //查看详情
            clickViewDetail(row) {
                this.$router.push({
                    path: '/teacherClass/discussDetail',
                    query: {
                        c_id: row.c_id,
                        course_record_id: row.course_record_id,
                        course_name: row.course_name,
                        className: this.className,
                    }
                })
            },
            goBack() {
                this.$router.go(-1)
            },
            goBackTwo() {
                this.$router.go(-2)
            },
        }
    }
</script>

<style scoped lang="scss">
    .discuss-container {
        height: calc(100% - 60px);
        padding: 30px 0;
        background: #F2F2F2;
        .discuss-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            width: 1200px;
            margin: 0 auto;
        }
    }
    ::v-deep .el-breadcrumb {
        margin-bottom: 20px;
        .el-breadcrumb__inner {
            color: #000;
        }
    }
    .discuss-list {
        display: flex;
        height: calc(100% - 106px);
        padding: 32px 50px;
        flex-direction: column;
        background-color: #fff;
        .detail-title {
            cursor: pointer;
        }
    }
    .pages-center {
        margin-bottom: 20px;
    }
</style>